// i80.js: the i80 Design System as Web Components.
//
//   <link rel="stylesheet" href="https://design.i80.dk/v/0.7.1/components.css">
//   <script type="module" src="https://design.i80.dk/v/0.7.1/i80.js"></script>
//   <i80-button color="primary">Save</i80-button>
//
// If the page doesn't link components.css, i80.js adds it (from the same folder),
// so a single <script> tag is enough to get started.

const HOST_CSS = `
/* The <i80-*> tags only wrap real elements; layout-wise they disappear. */
i80-button, i80-badge, i80-tag, i80-link-inline, i80-link-standalone, i80-text-input, i80-textarea, i80-select,
i80-checkbox, i80-radio, i80-toggle, i80-alert, i80-card, i80-dropdown, i80-dropdown-item,
i80-dropdown-separator, i80-dropdown-title, i80-checkbox-group, i80-radio-group, i80-toggle-group,
i80-tabs, i80-accordion, i80-accordion-item, i80-tooltip, i80-toast, i80-modal, i80-flyout { display: contents; }
i80-calendar, i80-coverage-map, i80-timeline, i80-flow, i80-pdf, i80-table, i80-advanced-table, i80-pagination, i80-application-state { display: block; }
i80-drawer, i80-dropzone { display: block; }
i80-icon, i80-icon-tile, i80-separator, i80-badge-count, i80-button-set { display: contents; }
i80-breadcrumb, i80-crumb, i80-app-header, i80-app-footer, i80-app-side-nav, i80-nav-link, i80-nav-title { display: contents; }
i80-file-input, i80-masked-input, i80-radio-card, i80-radio-card-group { display: contents; }
i80-copy-button, i80-copy-snippet, i80-reveal, i80-stepper-indicator, i80-stepper-list, i80-stepper-nav { display: contents; }
i80-page-header, i80-segmented-group { display: contents; }
i80-filter-bar, i80-filter-group, i80-filter-option, i80-applied-filter { display: contents; }
/* The filters dropdown is a flex item of the bar: the last one in the left group carries
   margin-right:auto, which needs a box of its own to push the actions to the end. */
i80-filter-dropdown { display: block; }
i80-code-block, i80-rich-tooltip, i80-time { display: contents; }
i80-text, i80-form-field, i80-form-fieldset, i80-form-error, i80-form-character-count { display: contents; }
/* The layout tags are the box that carries the layout, so they can't be display:contents:
   a flex or grid container with no box of its own has no layout either. The class from
   components.css raises this to flex or grid; with a tag attribute the layout moves onto
   the element inside, and only then does the tag itself step out of the way. */
i80-flex, i80-flex-item, i80-grid, i80-grid-item, i80-app-frame { display: block; }
i80-flex[tag], i80-flex-item[tag], i80-grid[tag], i80-grid-item[tag] { display: contents; }
/* The count and the error each sit in their own tag, so the rule in components.css that
   spaces an error after a count needs the tags in the selector to still match. */
.i80-form-field--layout-vertical i80-form-character-count + i80-form-error > .i80-form-error { margin-top: 8px; }
/* A dropdown segment is joined to its neighbours through .i80-segmented-group > .i80-dropdown,
   which here is the tag itself, so it needs a box of its own to be pulled onto them. */
.i80-segmented-group > i80-dropdown { display: block; }
i80-event, i80-coverage, i80-coverage-row, i80-need, i80-lane, i80-bar { display: none; }
i80-flow-palette, i80-flow-block, i80-flow-node, i80-flow-edge { display: none; }
i80-pdf-mark { display: none; }
`;

function ensureStyles() {
  if (!document.querySelector("style[data-i80-host]")) {
    const style = document.createElement("style");
    style.setAttribute("data-i80-host", "");
    style.textContent = HOST_CSS;
    document.head.append(style);
  }
  const linked = [...document.querySelectorAll('link[rel="stylesheet"]')].some((l) => /components\.css|i80\.css/.test(l.href));
  if (!linked && !document.documentElement.hasAttribute("data-i80-no-css")) {
    const link = document.createElement("link");
    link.rel = "stylesheet";
    link.href = new URL("./components.css", import.meta.url).href;
    link.setAttribute("data-i80-auto", "");
    document.head.append(link);
  }
}

ensureStyles();

export { setIconBase } from "./icons.js";
export * from "./components/button.js";
export * from "./components/text-input.js";
export * from "./components/dropdown.js";
export * from "./components/content.js";
export * from "./components/form.js";
export * from "./components/form-primitives.js";
export * from "./components/text.js";
export * from "./components/file-input.js";
export * from "./components/masked-input.js";
export * from "./components/radio-card.js";
export * from "./components/dialog.js";
export * from "./components/tabs.js";
export * from "./components/tooltip.js";
export * from "./components/icon.js";
export * from "./components/copy.js";
export * from "./components/reveal.js";
export * from "./components/stepper.js";
export * from "./components/calendar.js";
export * from "./components/coverage-map.js";
export * from "./components/timeline.js";
export * from "./components/flow.js";
export * from "./components/drawer.js";
export * from "./components/pdf.js";
export * from "./components/table.js";
export * from "./components/advanced-table.js";
export * from "./components/navigation.js";
export * from "./components/app.js";
export * from "./components/page-header.js";
export * from "./components/segmented-group.js";
export * from "./components/filter-bar.js";
export * from "./components/code-block.js";
export * from "./components/rich-tooltip.js";
export * from "./components/time.js";
export * from "./components/layout.js";
